import $ from 'jquery';

class PhotoCompetitionLoader {
	constructor() {
		this.url = '/vote/';
		this.events();
	}

	events() {
		const that = this,
			  $votes = $('#asset-gallery .vote'),
			  localName = this.getStorageKey($votes.first().attr('data-competition')),
			  competitionId = $votes.first().attr('data-competition');

		if (!$votes.length) {
			return;
		}

		$.ajaxSetup({
			headers: {
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			}
		});

		let voted = localStorage.getItem(localName);

		if (voted) {
			voted = $votes.filter('[data-vote=' + voted + ']').addClass('voted voted-indicator');
			$votes.not(voted).prop('disabled', true);
		}

		$votes.on('click', function(e) {
			e.preventDefault();

			const $this = $(this),
				  vote = $this.attr('data-vote');

			if ($this.hasClass('voted')) {
				that.removeVote(competitionId, vote);

				$votes.filter('[data-vote=' + vote + ']').removeClass('voted voted-indicator');
				$votes.not($this).prop('disabled', false);
			} else {
				that.saveVote(competitionId, vote);

				alert('Thank you for your vote. Please note that votes are limited to one per device.');
				
				$votes.filter('[data-vote=' + vote + ']').addClass('voted voted-indicator');
				$votes.not($this).prop('disabled', true);
			}
		});
	}

	getStorageKey(competitionId) {
		return 'photo-competition-' + competitionId;
	}

	saveVote(competitionId, voteId) {
		const that = this,
			  localName = this.getStorageKey(competitionId);

		$.ajax({
			type: 'post',
			cache: true,
			url: that.url + competitionId + '/' + voteId
		});

		localStorage.setItem(localName, voteId);
	}

	removeVote(competitionId, voteId) {
		const that = this,
			  localName = this.getStorageKey(competitionId);

		$.ajax({
			url: that.url + competitionId + '/' + voteId,
			type: 'delete'
		});

		localStorage.removeItem(localName);
	}
}

export default {
	init() {
		new PhotoCompetitionLoader();
	}
}


// WEBPACK FOOTER //
// ./src/js/modules/photoCompetitionLoader.js